export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/business_plans.d3339fe.svg";